export const isFileUnavailable = async (url: string) => {
  const req = await fetch(url, { method: 'head' })
  return !req.ok
}
